import styled from "styled-components";

export const InputArea = styled.div``;

export const InputContainer = styled.div`
    width: 115px;
    margin-top: 11px;
    display: flex;
    align-items: center;

  input[type="radio"] {
      width: 16px !important;
      height: 16px !important;
      border: #BEBEBE solid 1px;
  }

  input[type="radio"]:before {
      width: 16px !important; 
      height: 16px !important;
      border: #BEBEBE solid 1px;
  }

  input[type="radio"]:after {
      width: 16px !important; 
      height: 16px !important;
  }

  input[type="radio"]:checked:after {
      width: 10px !important; 
      height: 10px !important;
      top: 3.1px;
      left: 3.1px;
  }

    label {
          padding-left: 6px;
          font-size: 12px !important;
          font-weight: 400;
          text-align: left;
    }

  .selectDisabled {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 10px;
      color: #7a7a7a;
      label {
          padding-left: 6px;
          font-size: 12px !important;
          font-weight: 500;
          text-align: left;
      }

      input[type="radio"]:before {
          background: #F2F2F2;
      }    
  }
`